import {nomeMeses} from "@/helpers";

const opcoes = {
  chart: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    },
    animations: {
      enabled: false
    }
  },
  plotOptions: {
    bar: {
      endingShape: "flat",
      borderRadius: 1,
      dataLabels: {
        position: "top",
        orientation: "vertical"
      }
    }
  },
  grid: {
    show: true,
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  labels: [],
  legend: {
    show: true,
    position: "top",
    offsetY: 5,
    horizontalAlign: "center",
    markers: {
      width: 13,
      height: 13,
      radius: 0
    }
  },
  dataLabels: {
    enabled: true,
    offsetY: 5,
    enabledOnSeries: [0, 1],
    style: {
      fontSize: "11px",
      fontWeight: undefined,
      colors: ["#000"]
    },
    background: {
      enabled: false
    },
    formatter: function (val) {
      return formatter(val) || "";
    }
  },
  markers: {
    size: [0, 0, 0],
    colors: "#888",
    strokeColors: "#888"
  },
  stroke: {
    show: true,
    curve: "smooth",
    colors: ["", "", "#999"],
    width: 1
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: {
      show: true,
      formatter: valor => {
        if (typeof valor != "string") return valor;
        const dt = valor.split("/");

        return `${meses[parseInt(dt[0]) - 1] || dt[0]} de ${dt[1]}`;
      }
    },
    y: {
      show: true,
      format: "dd MMM",
      formatter: valor => {
        return new Intl.NumberFormat("pt-BR", {
          style: "decimal",
          maxDigits: 4,
          minimumFractionDigits: 4
        }).format(valor);
      }
    }
  },
  fill: {
    opacity: [1, 1, 0.2]
  },
  xaxis: {
    labels: {
      minWidth: 50,
      maxWidth: 50,
      formatter: referencia => {
        if (!`${referencia}`.includes('/')) return 'Mês';

        const [mes] = `${referencia}`.split('/');
        return (nomeMeses[parseInt(mes) - 1] || ' ').substring(0, 3);
      }
    }
  },
};

const meses = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

function formatter(n) {
  var ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" }
  ];

  for (var i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      return (
        (Math.round(n) / ranges[i].divider).toFixed(2).toString() +
        ranges[i].suffix
      );
    }
  }

  const r = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    maxDigits: 2
  }).format(n);

  return r == 0 ? "" : r;
}

export { opcoes };
